
import FilterTick from "../../../assets/filled/FilterTick.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function FilterTickIcon({ className, dataTestid = "FilterTickIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <FilterTick data-testid={dataTestid} className={classes} {...rest} />
  );
}
